var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-pc-page"},[_c('Banner'),_c('Title',{attrs:{"info":{
      imgUrl:'introduction.png',
      name: '大会介绍',
      enName:'INTRODUCTION',
    }}}),_c('Introduction'),_c('Title',{attrs:{"info":{
      imgUrl:'schedule.png',
      name: '大会议程',
      enName:'AGENDA'
    }}}),_c('Schedule'),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode-zijie"},[_c('img',{staticClass:"qr",attrs:{"src":require("../../assets/images/qrcode-zijie.png"),"alt":""}}),_c('div',[_vm._v("更多TikTok for Business ")]),_c('div',[_vm._v(" 出海营销资讯")])])}]

export { render, staticRenderFns }